import { Fragment } from 'react';
import { Box } from 'components/common/box';
import { Badge, Button } from 'components/common';
import { FormSection } from 'components/common/form';

import type { BadgeCategory, BadgeSize } from 'components/common/Badge';
import type { ButtonCategory, ButtonSize } from 'components/common/Button';
import type { IconProp } from 'components/common/icons/Icon';

const SiteSettingsThemesComponents = () => {
  const testIcons = [
    'check',
    ['far', 'clock'],
    'trash-alt',
    ['far', 'calendar-alt'],
    ['far', 'file-pdf'],
    'award',
    'pen',
    'cog',
    'tools',
    'tasks',
    'user',
    'chart-bar'
  ] as IconProp[];

  const badgeCategories = [
    'dark',
    'default',
    'error',
    'error-light',
    'success',
    'success-light',
    'warning',
    'warning-light'
  ] as BadgeCategory[];

  const badgeSizes = ['small', 'medium', 'large'] as BadgeSize[];

  const buttonCategories = [
    'default',
    'light',
    'lighter',
    'transparent',
    'white',
    'success',
    'danger'
  ] as ButtonCategory[];

  const buttonSizes = [
    'small',
    'header',
    'medium',
    'large',
    'huge'
  ] as ButtonSize[];

  return (
    <div className="components">
      <Box padding={0} title={'Preview components'}>
        <div className="content">
          <FormSection title={'Badges'}>
            {badgeSizes.map((size) => (
              <Fragment key={size}>
                <div className="badges">
                  {badgeCategories.map((category, i) => (
                    <Badge
                      key={category}
                      category={category}
                      icon={testIcons[i]}
                      size={size}
                    />
                  ))}
                </div>
                <div className="badges">
                  {badgeCategories.map((category) => (
                    <Badge
                      key={category}
                      category={category}
                      size={size}
                      text="Test string"
                    />
                  ))}
                </div>
                <div className="badges">
                  {badgeCategories.map((category, i) => (
                    <Badge
                      key={category}
                      category={category}
                      icon={testIcons[i]}
                      size={size}
                      text="Test string"
                    />
                  ))}
                </div>
                <div className="badges">
                  {badgeCategories.map((category, i) => (
                    <Badge
                      key={category}
                      category={category}
                      newItems={5}
                      size={size}
                      text="Test string"
                    />
                  ))}
                </div>
                <div className="badges">
                  {badgeCategories.map((category, i) => (
                    <Badge
                      key={category}
                      category={category}
                      onClose={() => undefined}
                      size={size}
                      text="Test string"
                    />
                  ))}
                </div>
              </Fragment>
            ))}
          </FormSection>

          <FormSection title={'Buttons'}>
            {buttonSizes.map((size) => (
              <Fragment key={size}>
                <div className="buttons">
                  {buttonCategories.map((category, i) => (
                    <Button
                      key={category}
                      category={category}
                      icon={testIcons[i]}
                      size={size}
                    />
                  ))}
                </div>
                <div className="buttons">
                  {buttonCategories.map((category) => (
                    <Button
                      key={category}
                      category={category}
                      size={size}
                      text="Test string"
                    />
                  ))}
                </div>
                <div className="buttons">
                  {buttonCategories.map((category, i) => (
                    <Button
                      key={category}
                      category={category}
                      icon={testIcons[i]}
                      size={size}
                      text="Test string"
                    />
                  ))}
                </div>
              </Fragment>
            ))}
          </FormSection>
        </div>
      </Box>

      <style jsx>{`
        .content {
          overflow-x: auto;
        }
        .badges {
          display: flex;
          gap: 10px;
          margin-bottom: 20px;
        }
        .buttons {
          display: flex;
          gap: 10px;
          margin-bottom: 20px;
        }
      `}</style>
    </div>
  );
};

export default SiteSettingsThemesComponents;
